import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../utils/api';
import * as storage from '../utils/storage';
import useAuthStore from '../stores/useAuthStore';

const KEY = ['projects'];

function normalize(p) {
  return { ...p, id: p.projectId || p.id, headings: p.headings || [] };
}

export function useProjects() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: KEY,
    enabled: isAuthenticated,
    queryFn: async () => {
      const projects = await api.fetchProjects();
      const normalized = projects.map(normalize);
      storage.saveProjects(normalized);
      return normalized;
    },
    initialData: () => {
      const local = storage.loadProjects?.() || [];
      return local.length ? local.map(normalize) : undefined;
    },
  });
}

export function useCreateProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (project) => api.createProject(project),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (project) => api.updateProject(project),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.deleteProject(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}
